import type { FC, ReactNode } from 'react';

import { RecentDealsVariant } from '@makemydeal/dr-activities-recent-deals';

import { useRecentDealsVariant } from '../hooks/useRecentDealsVariant';
import RecentDealsContainer from './RecentDealsContainer';
import { RecentDealsLayoutContent } from './RecentDealsLayout.style';

export const RecentDealsLayout: FC<{ children: ReactNode }> = ({ children }) => {
    const variant = useRecentDealsVariant();

    return (
        <>
            <RecentDealsContainer variant={variant} />
            <RecentDealsLayoutContent $docked={variant === RecentDealsVariant.DOCKED} data-testid="recent-deals-layout-content">
                {children}
            </RecentDealsLayoutContent>
        </>
    );
};
